import IAdminState from "@/types/admin";

const getters = {
  adminState: (state: IAdminState): IAdminState => state,
};

export default getters;
